import React from 'react';
import { createMuiTheme } from '@material-ui/core';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';

const theme = createMuiTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ['WixMadeforDisplay'].join(','),
    },

    breakpoints: {
      values: {
        sm: 600, // Small screen / phone
        md: 920, // Medium screen / tablet
        lg: 1200, // Large screen / desktop
        xl: 1500,
        xxl: 1800,
      }
    },

    palette: {
      contrastThreshold: 3,
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#d01c1f',
        contrastText: '#fff',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        // light: will be calculated from palette.primary.main,
        //main: '#0abb87',
        main: '#b5b5c3',
        // dark: will be calculated from palette.primary.main,
        contrastText: '#ffffff',
      },
      error: {
        // light: will be calculated from palette.primary.main,
        main: '#0b5785',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      success: {
        // light: will be calculated from palette.primary.main,
        main: '#0abb87',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
    },
    overrides: {
      MuiButton: {
        // raisedPrimary: {
        //   color: 'white',
        // },
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */

    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        // raisedPrimary: { color: '#fff' },
        disableRipple: true, // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1,
      },
    },
  }
);

export default function ThemeProvider(props) {
  const { children } = props;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
